import { Injectable } from '@angular/core';
import * as JSPM from 'jsprintmanager';
import { style } from '@angular/animations';
declare const Neodynamic: any;
@Injectable({
  providedIn: 'root'
})
export class PrinterService {
  private rawCommands = '';

  private commands = {
    initializePrinter: '\x1B@', // Initialize printer
    setCp850CodePage: '\x1Bt\x0B', // Set cp850 code page
    setCp858CodePage: '\x1Bt\x0C', // Set cp858 code page
    setWindows1252CodePage: '\x1Bt\x0D', // Set windows-1252 code page
    newLine: '\x0A', // New line
    prevCutSpace: '\x1B\x64\x04', // Previous cut space (4 lines)
    drawLine: '-'.repeat(48), // Draw separator horizontal line of 48 characters 
    cutPaper: '\x1D\x56\x00', // Cut paper (partial)
    openCashDrawer: '\x1Bp\x00\x0F\x96', // Open cash drawer
    beep: '\x07', // Beep
    delay100ms: '\x1B._', // Delay 100ms
    alignLeft: '\x1B\x61\x00', // Align left
    alignCenter: '\x1B\x61\x01', // Align center
    alignRight: '\x1B\x61\x02', // Align right
    normalFont: '\x1B\x21\x00', // Font size normal
    boldFont: '\x1B\x45\x01', // Font bold on
    boldFontOff: '\x1B\x45\x00', // Font bold off
    doubleHeight: '\x1B\x21\x10', // Height double
    doubleWidth: '\x1B\x21\x20', // Width double
    doubleHeightAndWidth: '\x1B\x21\x30', // Height and width double
    underline: '\x1B\x2D\x01', // Underline
    underlineOff: '\x1B\x2D\x00' // Underline off
  };

  constructor() { }

  private logRawCommands() {
    console.log('Comandos generados:', this.rawCommands);
  }

  private initializePrinter() {
    this.rawCommands = '';
    this.rawCommands += this.commands.initializePrinter;
    this.rawCommands += this.commands.setCp858CodePage;
  }

  private newLine() {
    this.rawCommands += this.commands.newLine;
  }

  private concatText(text: string) {
    // Mientras no se corrija la impresión de los tildes se retorna el text envuelto en normalizeText, 
    // luego no será necesario utilizar la función normalizeText
    this.rawCommands += text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    // this.rawCommands += text;
  }

  private prevCutSpace() {
    this.rawCommands += this.commands.prevCutSpace;
  }

  private drawLine() {
    this.rawCommands += this.commands.drawLine + this.commands.newLine;
  }

  private cutPaper() {
    this.rawCommands += this.commands.cutPaper;
  }

  private openCash() {
    this.rawCommands += this.commands.openCashDrawer;
  }

  private beep() {
    this.rawCommands += this.commands.beep;
  }

  private delay100ms() {
    this.rawCommands += this.commands.delay100ms;
  }

  private alignLeft() {
    this.rawCommands += this.commands.alignLeft;
  }

  private alignCenter() {
    this.rawCommands += this.commands.alignCenter;
  }

  private alignRight() {
    this.rawCommands += this.commands.alignRight;
  }

  private normalFont() {
    this.rawCommands += this.commands.normalFont;
  }

  private boldFont() {
    this.rawCommands += this.commands.boldFont;
  }   

  private boldFontOff() { 
    this.rawCommands += this.commands.boldFontOff;
  }

  private doubleHeight() {
    this.rawCommands += this.commands.doubleHeight;
  } 

  private doubleWidth() {
    this.rawCommands += this.commands.doubleWidth;
  }

  private doubleHeightAndWidth() {
    this.rawCommands += this.commands.doubleHeightAndWidth;
  }

  private underline() {
    this.rawCommands += this.commands.underline;
  }

  private underlineOff() {
    this.rawCommands += this.commands.underlineOff;
  }

  private typesDict = {
    UNDEFINED: -1,
    TOTAL: 0,
    INVOICE: 1, // Restaurante
    TARIFAS: 6, // Titulo
    SERVICIOS: 7,
    TARIFAS_line: 8,
    INVOICE_line: 9,
    SERVICIOS_line: 10,
  }

  private makeInvoiceString(name, ppu, units, total, length, type = this.typesDict.INVOICE) {
    if (!name || name == null) name = "";
    if (!ppu || ppu == null) ppu = "";
    if (!units || units == null) units = "";
    if (!total || total == null) total = "";
    if (total == 0) total = "0.00";
    let invoicestring = '';
    let totalSection = this.convertNumberToStringIfNumber(total).replace('.', ',');
    if (totalSection.length == 1 && totalSection != " ") totalSection = "  " + totalSection;
    if (totalSection.length == 2) totalSection = "  " + totalSection;
    if (totalSection.length == 3) totalSection = "  " + totalSection;
    if (totalSection.length == 4) totalSection = "  " + totalSection;
    if (totalSection.length == 5) totalSection = " " + totalSection;
    if (totalSection.length == 6) totalSection = "" + totalSection;

    let ppuSection = this.convertNumberToStringIfNumber(ppu).replace('.', ',');
    if(type === this.typesDict.TARIFAS) {
      ppuSection = " " + ppuSection + "    ";
    } else {
      if (ppuSection.length == 3) ppuSection = " " + ppuSection;
      if (ppuSection.length == 4) ppuSection = " " + ppuSection;
      if (ppuSection.length == 5) ppuSection = " " + ppuSection;
    }
    /*if (ppuSection.trim().length >= 5 && type === this.typesDict.SERVICIOS) ppuSection = ppuSection + "        ";
    if (ppuSection.trim().length >= 5 && type === this.typesDict.INVOICE) ppuSection = " " + ppuSection + "   ";*/

    let unitsString = units.toString();
    if ((type == this.typesDict.INVOICE || type == 5) && unitsString.endsWith('.00')) units = Math.trunc(Number(units)).toString();
    if(type == 1 && (!units || units == null)) units = "0";
    units = units.toString();
    if (units.length == 1) units = " " + units;
    if (units.length == 2) units = " " + units;
    if (units.length == 3) units = " " + units;
    if (units.length == 4) units = " " + units;
    if (units.length == 5) units = " " + units;
      
    let priceSection = ppuSection + " " + units + "  " + totalSection;
    let nameSection = "";
    const nameSectionLimit = length - priceSection.length - 5;
    if(name.trim().length >= nameSectionLimit && (this.typesDict.TARIFAS_line == type || this.typesDict.INVOICE_line == type || this.typesDict.SERVICIOS_line == type)) {
      name = name.substring(0, nameSectionLimit).trim() + '...';
    }
    nameSection = name.padEnd(length - priceSection.length).substring(0, length - priceSection.length);
    invoicestring = nameSection + priceSection;


    if (type > 1 && type < 5) invoicestring = "\x1B\x21\x08" + invoicestring + "\x1B\x21\x00";

    // Mientras no se corrija la impresión de los tildes se retorna el invoice string .normalize, 
    // luego de correjido no será necesario utilizar .normalize y solo se retornará invoicestring
    // return this.rawCommands += invoicestring;
    // return this.rawCommands += invoicestring.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return invoicestring;
  }

  private convertNumberToStringIfNumber(variable) {
    if (typeof variable === 'number') {
      return variable.toString();
    } else {
      return variable; // Devuelve la variable sin cambios si no es un número
    }
  }

  private roundNumberFunction(variable) {
    return Math.round((variable + Number.EPSILON) * 100) / 100
  }

  private listHasValues(array) {
    // console.log('HAS VALUES:', Array.isArray(array) && array.length > 0 && array.every(obj => {
    //   return Object.values(obj).every(value => value !== null);
    // }));
    return Array.isArray(array) && array.length > 0 && array.every(obj => {
      return Object.values(obj).every(value => value !== null);
    });
  }

  private async jspmConnect(): Promise<boolean> {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true; // Ya está conectado
    }

    // Configurar la reconexión automática y iniciar JSPM
    // JSPM.JSPrintManager.license_url = "https://movin.cloud/backend/index.php?resource=jspm-printer&req=get-jspm-license";
    JSPM.JSPrintManager.license_url = "https://www.neodynamic.com/licenses/jspm/v7/movin-cloud";
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();

    return new Promise((resolve, reject) => {
      // Manejar cambios de estado de la conexión WebSocket
      JSPM.JSPrintManager.WS.onStatusChanged = () => {
        if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
          resolve(true); // Conexión establecida
        } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
          reject(new Error('JSPrintManager no está instalado o no se está ejecutando'));
          console.log('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');

        } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
          reject(new Error('JSPM ha bloqueado este sitio web'));
          console.log('JSPM has blocked this website!');
        }
      };
    });
  }

  public async printInvoiceNormalized(infoTicket) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const { ip, port, invoice, imagepath } = infoTicket;
        const printer = new JSPM.NetworkPrinter(port, ip);
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        // Encabezado
        let i = 0;
        for (let key in invoice.header) {
          if (i > 0) {
            this.newLine();
            this.normalFont();
          }
          this.alignCenter();
          this.doubleHeightAndWidth();
          this.concatText(invoice.header[key]);
          this.newLine();
          ++i;
        }

        // Encabezado 2
        this.newLine();
        this.normalFont();
        for (let key in invoice.header2) {
          this.concatText(invoice.header2[key]);
          this.newLine();
        }

        // Contenido del ticket
        this.normalFont();
        this.newLine();
        this.newLine();
        this.makeInvoiceString("PRODUCTO", "PVP", " UDS", "TOTAL", 48, 2);
        this.drawLine();
        for (let plu of invoice.plus) {
          this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1);
        }

        // Imprimir importe total ticket
        // IVA
        this.drawLine();
        let cuota = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
        let base = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1) - this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
        base = this.roundNumberFunction(base);
        this.makeInvoiceString("IVA: 10%", "BASE: " + cuota, " ", "Cuota: " + base, 48, 0);

        // Total
        this.drawLine();
        this.doubleHeight();
        this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0);
        this.normalFont();
        this.drawLine();

        // Comensales
        this.alignRight();
        for (let key in invoice.total2) {
          this.concatText(invoice.total2[key]);
          this.newLine();
        }
        this.drawLine();
        this.drawLine();
        this.newLine();

        // Pie
        this.alignLeft();
        for (let key in invoice.footer) {
          this.concatText(invoice.footer[key]);
          this.newLine();
        }
        this.newLine();
        this.drawLine();

        // Pie del cliente (si existe)
        if (invoice.footerCliente) {
          this.alignLeft();
          for (let key in invoice.footerCliente) {
            if (invoice.footerCliente[key]) {
              const text = invoice.footerCliente[key].trim();
              this.concatText(text);
              this.newLine();
            }
          }
          this.drawLine();
        }

        // Pie 2
        this.newLine();
        this.alignCenter();
        let isFirstIteration = true;
        for (let key in invoice.footer2) {
          if (invoice.footer2[key]) {
            const text = invoice.footer2[key].trim();
            // Verifica si es la primera iteración y agrega los comandos especiales
            if (isFirstIteration) {
              this.doubleHeightAndWidth();
              this.boldFont();
              this.concatText(text);
              this.newLine();
              this.newLine();
              isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
            } else {
              this.normalFont();
              this.boldFontOff();
              this.concatText(text);
              this.newLine();
            }
          }
        }

        this.newLine();

        const date = new Date();
        const nowDate = date.toLocaleDateString('en-US', {
          timeZone: 'CET',
        });
        const nowTime = date.toLocaleTimeString('en-US', {
          timeZone: 'CET',
        });
        const nowText = `Printed at ${nowDate} ${nowTime}`;

        this.concatText(nowText);
        this.newLine();
        this.newLine();

        this.prevCutSpace();
        this.cutPaper();

        this.logRawCommands();

        // Crear un ClientPrintJob
        const commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.printerCommands = this.rawCommands;


        // Logo
        if (imagepath && imagepath.length > 0) {
          escpos.ESCPOSImage.load('/assets/goiko-grill-logoimpresora.png')
            .then(logo => {
              const escposCommands = doc
                .image(logo, escpos.BitmapDensity.D24)
                .generateUInt8Array();

              // create ClientPrintJob
              const imagePrintJob = new JSPM.ClientPrintJob();
              imagePrintJob.clientPrinter = printer;
              imagePrintJob.binaryPrinterCommands = escposCommands;

              const commandsPrintGroupJob = new JSPM.ClientPrintJobGroup();
              commandsPrintGroupJob.jobs.push(imagePrintJob);
              commandsPrintGroupJob.jobs.push(commandsPrintJob);

              commandsPrintGroupJob.sendToClient();
              console.log('Print Group Job sent to printer', commandsPrintGroupJob);
            });
        } else {
          commandsPrintJob.sendToClient();
        }
        console.log('Print Job sent to printer', commandsPrintJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }

  }

  public async printCommandNormalized(ip, port, invoice, beep) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const printer = new JSPM.NetworkPrinter(port, ip);

        this.initializePrinter();

        // Encabezado
        for (let key in invoice.header) {
          if (key === "cancelado" || key === "camarero_o_influencer") {
            this.alignCenter();
            this.doubleHeightAndWidth();
            this.boldFont();
            this.concatText(invoice.header[key]);
            this.newLine();
            this.normalFont();
            this.boldFontOff();
            this.drawLine();
            this.drawLine();
          } else {
            this.alignCenter();
            this.boldFont();
            this.concatText(invoice.header[key]);
            this.normalFont();
            this.newLine();
          }
        }

        // Encabezado 2
        for (let key in invoice.header2) {
          if (!invoice.header2[key] || invoice.header2[key] === undefined || invoice.header2[key] === "") {
            continue;
          }
          if (key === "table" || key === "sala") {
            this.doubleHeightAndWidth();
            this.concatText(invoice.header2[key]);
            this.newLine();
            this.normalFont();
          } else if (key === "num_comensales") {
            this.doubleHeight();
            this.concatText(invoice.header2[key]);
            this.newLine();
            this.normalFont();
          } else if (key === "comment") {
            this.drawLine();
            this.doubleHeight();
            this.concatText(invoice.header2[key]);
            this.newLine();
            this.normalFont();

          } else {
            this.concatText(invoice.header2[key]);
            this.newLine();
          }
        }
        this.drawLine();

        // Imprimir el contenido del ticket
        for (let plu of invoice.plus) {
          this.normalFont();
          this.drawLine();
          this.alignCenter();
          this.doubleHeightAndWidth();
          this.concatText(plu.category);
          this.newLine();
          for (let p of plu.products) {
            let stringPRoduct = "X" + Number(p.units).toString() + " " + p.name;
            this.alignLeft();
            this.normalFont();
            this.drawLine();
            this.doubleHeightAndWidth();
            this.concatText(stringPRoduct);
            if (p.suplementos && p.suplementos.length && p.suplementos.length > 0) {
              for (let sup of p.suplementos) {
                if (beep) {
                  this.newLine();
                  this.concatText("-> EXTRA " + sup.name);
                } else {
                  this.newLine();
                  this.concatText("-> " + sup.name);
                };
              }
            }
            if (p.description) {
              this.newLine();
              this.concatText("// " + p.description)

            };
          }
        }

        this.normalFont();
        this.boldFontOff();

        // Pie de página
        this.newLine();
        this.newLine();
        this.drawLine();
        this.drawLine();
        if (invoice.footer) {
          for (let key in invoice.footer) {
            this.alignCenter();
            this.doubleHeightAndWidth();
            this.concatText(invoice.footer[key]);
            this.newLine();
            this.normalFont();
            this.drawLine();
            this.drawLine();
          }
        }

        this.prevCutSpace();
        this.cutPaper();

        if (beep) {
          this.openCash();
          for (let i = 0; i < 30; i++) {
            this.beep();
            this.delay100ms();
          }
        }

        this.logRawCommands();

        // Crear un ClientPrintJob
        const printJob = new JSPM.ClientPrintJob();
        printJob.clientPrinter = printer;
        printJob.printerCommands = this.rawCommands;

        printJob.sendToClient();

      } 
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  }

  public async openCashDrawerNormalized(ip, port) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const printer = new JSPM.NetworkPrinter(port, ip);
        console.log("Opening Cash: " + ip + ":" + port);

        this.initializePrinter();
        this.openCash();

        this.logRawCommands();

        const printJob = new JSPM.ClientPrintJob();
        printJob.clientPrinter = printer;
        printJob.printerCommands = this.rawCommands;

        printJob.sendToClient();
      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  };

  public async printMovementNormalized(ip, port, movement) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const printer = new JSPM.NetworkPrinter(port, ip, "cp850");
        this.initializePrinter();

        // Encabezado
        this.drawLine();
        this.alignCenter();
        for (let key in movement.header) {
          this.doubleHeight();
          this.concatText(movement.header[key]);
          this.newLine();
        }
        this.normalFont();
        this.drawLine();
        this.newLine();

        // Encabezado 2
        this.alignLeft();
        for (let key in movement.header2) {
          this.concatText(movement.header2[key]);
          this.newLine();
        }
        this.newLine();

        // Pie
        for (let key in movement.footer) {
          this.doubleHeight();
          this.concatText(movement.footer[key]);
          this.newLine();
        }
        this.normalFont();
        this.newLine();
        this.drawLine();

        this.newLine();
        this.prevCutSpace();
        this.cutPaper();

        this.logRawCommands();

        const printJob = new JSPM.ClientPrintJob();
        printJob.clientPrinter = printer;
        printJob.printerCommands = this.rawCommands;

        printJob.sendToClient();

      } 
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }

  }

  public async printCierreOrSnapshotCajaNormalized(ip, port, info, isSnapshot) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const printer = new JSPM.NetworkPrinter(port, ip);
        this.initializePrinter();

        // Encabezado (SNAPSHOT o CIERRE CAJA)
        this.drawLine();
        this.alignCenter();
        this.doubleHeightAndWidth();
        this.boldFont();
        this.concatText(isSnapshot ? "- SNAPSHOT (X) -" : "- CIERRE CAJA (Z) -");
        this.newLine();
        this.normalFont();
        this.boldFontOff();
        this.drawLine();

        // Referencia y datos del encabezado
        this.alignLeft();
        this.boldFont();
        this.doubleHeight();
        this.concatText(info.referencia)
        this.newLine();
        this.boldFontOff();
        this.normalFont();

        for (let key in info.header) {
          this.concatText(info.header[key]);
          this.newLine();
        }

        this.drawLine();
        this.drawLine();

        // Sección "AUTOMÁTICOS SISTEMA"
        this.boldFont();
        this.doubleHeightAndWidth();
        this.concatText("AUTOMATICOS SISTEMA");
        this.newLine();
        this.normalFont();
        this.drawLine();

        // Saldo inicial
        this.doubleHeight();
        this.makeInvoiceString("Saldo inicial:", "", "", info.saldo_inicial, 48, -1);
        this.newLine();
        this.normalFont();
        this.drawLine();

        // Cobros registrados
        this.boldFont();
        this.makeInvoiceString("Cobros Registados (incluye propinas)", "", "", info.importe_ingresos, 48, 2);
        this.newLine();
        this.boldFontOff();

        for (let c of info.cobros) {
          this.makeInvoiceString("  " + c.name, "", "", c.importe, 48, -1);
          this.newLine();
        }

        // Otros movimientos
        this.boldFont();
        this.makeInvoiceString("Otros Movimientos", "", "", info.importe_movimientos, 48, 2);
        this.newLine();

        for (let m of info.movimientos) {
          this.makeInvoiceString("  " + m.name, "", "", m.importe, 48, -1);
          this.newLine();
        }

        // Propinas
        this.boldFont();
        this.makeInvoiceString("Propinas", "", "", info.importe_propinas, 48, 2);
        this.newLine();
        this.boldFontOff();
        this.drawLine();

        // SALDO FINAL CALCULADO
        this.boldFont();
        this.doubleHeight();
        this.makeInvoiceString("SALDO FINAL:", "", "", info.saldo_final_calculado, 48, -1);
        this.newLine();
        this.normalFont();

        for (let s of info.totales) {
          this.makeInvoiceString("  " + s.name, "", "", s.importe_calculado, 48, 2);
          this.newLine();
        }

        this.boldFontOff();
        this.drawLine();
        this.drawLine();

        // Sección "MANUAL CAMARERO"
        this.boldFont();
        this.doubleHeightAndWidth();
        this.concatText("MANUAL CAMARERO");
        this.newLine();
        this.boldFontOff();
        this.normalFont();
        this.drawLine();

        // SALDO FINAL MANUAL
        this.boldFont();
        this.doubleHeight();
        this.makeInvoiceString("SALDO FINAL:", "", "", info.saldo_final_manual, 48, -1);
        this.newLine();
        this.normalFont();

        for (let s of info.totales) {
          this.makeInvoiceString("  " + s.name, "", "", s.importe_manual, 48, 2);
          this.newLine();
        }

        this.boldFontOff();
        this.drawLine();

        this.newLine();
        this.prevCutSpace();

        this.cutPaper();

        this.logRawCommands();

        const printJob = new JSPM.ClientPrintJob();
        printJob.clientPrinter = printer;
        printJob.printerCommands = this.rawCommands;

        printJob.sendToClient();
        console.log('Print Job sent to printer', printJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);

    }

  }

  public async printPedidoNormalized(pedidoToPrint) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const { ip, port, pedido, imagepath } = pedidoToPrint;

        const printer = new JSPM.NetworkPrinter(port, ip);
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        this.initializePrinter();

        // Encabezado
        this.alignCenter();
        for (let key in pedido.header) {
          if (pedido.header[key]) {
            const text = pedido.header[key].trim();
            this.boldFont();
            this.doubleHeightAndWidth();
            this.concatText(text);
            this.newLine();
            this.newLine();
          }
        }
        this.boldFontOff();
        this.normalFont();

        // Encabezado 2
        this.alignCenter();
        for (let key in pedido.header2) {
          if (pedido.header2[key]) {
            const text = pedido.header2[key].trim();
            this.normalFont();
            this.concatText(text);
            this.newLine();
          }
        }

        // Contenido del ticket
        this.newLine();
        this.newLine();
        this.boldFont();
        this.makeInvoiceString("PRODUCTO", "PVP", "UDS", "TOTAL", 48, 2);
        this.newLine();
        this.drawLine();
        for (let plu of pedido.plus) {
          this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1);
          this.newLine();
        }

        // Total
        this.drawLine();
        this.boldFont();
        this.doubleHeight();
        this.makeInvoiceString("Total (impuestos incluidos)", "", "", pedido.totalImport['importe_ticket'], 48, 1);
        this.newLine();
        this.boldFontOff();
        this.normalFont();
        this.drawLine();

        // Comensales
        this.alignRight();
        for (let key in pedido.total2) {
          if (pedido.total2[key]) {
            const text = pedido.total2[key].trim();
            this.concatText(text);
            this.newLine();
          }
        }
        this.drawLine();
        this.drawLine();
        this.newLine();

        // Pie
        this.alignLeft();
        for (let key in pedido.footer) {
          if (pedido.footer[key]) {
            const text = pedido.footer[key].trim();
            this.concatText(text);
            this.newLine();
          }
        }
        this.newLine();
        this.drawLine();

        // Pie del cliente
        if (pedido.footerCliente) {
          this.alignLeft();
          for (let key in pedido.footerCliente) {
            if (pedido.footerCliente[key]) {
              const text = pedido.footerCliente[key].trim();
              this.concatText(text);
              this.newLine();
            }
          }
          this.drawLine();
        }

        // Pie 2
        this.newLine();
        this.alignCenter();
        let isFirstIteration = true;
        for (let key in pedido.footer2) {
          if (pedido.footer2[key]) {
            const text = pedido.footer2[key].trim();
            // Verifica si es la primera iteración y agrega los comandos especiales
            if (isFirstIteration) {
              this.doubleHeightAndWidth();
              this.boldFont();
              this.concatText(text);
              this.newLine();
              this.newLine();
              isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
            } else {
              this.normalFont();
              this.boldFontOff();
              this.concatText(text);
              this.newLine();
            }
          }
        }

        this.newLine();

        // Fecha y hora
        const date = new Date();
        const nowDate = date.toLocaleDateString('en-US', {
          timeZone: 'CET',
        });
        const nowTime = date.toLocaleTimeString('en-US', {
          timeZone: 'CET',
        });
        const nowText = `Printed at ${nowDate}, ${nowTime}`;

        this.concatText(nowText);
        this.newLine();
        this.newLine();

        this.prevCutSpace();
        this.cutPaper();

        this.logRawCommands();

        // Crear un ClientPrintJob
        const commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.printerCommands = this.rawCommands;

        console.log('Print Job sent to printer', commandsPrintJob);

        // Logo
        if (imagepath && imagepath.length > 0) {
          escpos.ESCPOSImage.load('/assets/goiko-grill-logoimpresora.png')
            .then(logo => {
              const escposCommands = doc
                .image(logo, escpos.BitmapDensity.D24)
                .generateUInt8Array();

              // create ClientPrintJob
              const imagePrintJob = new JSPM.ClientPrintJob();
              imagePrintJob.clientPrinter = printer;
              imagePrintJob.binaryPrinterCommands = escposCommands;

              const commandsPrintGroupJob = new JSPM.ClientPrintJobGroup();
              commandsPrintGroupJob.jobs.push(imagePrintJob);
              commandsPrintGroupJob.jobs.push(commandsPrintJob);

              commandsPrintGroupJob.sendToClient();
              console.log('Print Group Job sent to printer', commandsPrintGroupJob);
            });
        } else {
          commandsPrintJob.sendToClient();
        }

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  }

  public async openCashDrawer(ip, port) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();
        const printer = new JSPM.NetworkPrinter(port, ip);
        console.log("Opening Cash: " + ip + ":" + port);

        doc.cashDraw();

        const print = doc.generateUInt8Array();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);
      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  };

  public async printMovement(ip, port, movement) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        // Encabezado
        doc.drawLine();
        for (let key in movement.header) {
          doc.align(escpos.TextAlignment.Center)
             .size(0, 1)
             .text(movement.header[key])
             .size(0, 0);
        }
        doc.drawLine();

        // Encabezado 2
        for (let key in movement.header2) {
          doc.align(escpos.TextAlignment.LeftJustification)
             .text(movement.header2[key]);
        }
        doc.newLine();

        // Pie
        for (let key in movement.footer) {
          doc.size(0, 1)
             .text(movement.footer[key])
             .size(0, 0);
        }
        doc.drawLine()
           .feed(5)
           .cut();

        const print = doc.generateUInt8Array();

        this.logRawCommands();
        
        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }

  }

  public async printCommand(ip, port, invoice, beep) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        // Encabezado
        for (let key in invoice.header) {
          if (key === "cancelado" || key === "camarero_o_influencer") {
            doc.align(escpos.TextAlignment.Center)
               .size(1, 2)
               .style([escpos.FontStyle.Bold])
               .text(invoice.header[key])
               .size(0, 0)
               .style([escpos.FontStyle.Normal])
               .drawLine()
               .drawLine()
               .newLine();

          } else {
            doc.align(escpos.TextAlignment.Center)
               .style([escpos.FontStyle.Bold])
               .text(invoice.header[key])
               .style([escpos.FontStyle.Normal])
          }
        }

        // Encabezado 2
        for (let key in invoice.header2) {
          if (!invoice.header2[key] || invoice.header2[key] === undefined || invoice.header2[key] === "") {
            continue;
          }
          if (key === "table" || key === "sala") {
            doc.size(1, 1)
               .text(invoice.header2[key])
               .size(0, 0);
          } else if (key === "num_comensales") {
            doc.size(0, 1)
               .text(invoice.header2[key])
               .size(0, 0);
          } else if (key === "comment") {
            doc.drawLine()
               .size(0, 1)
               .text(invoice.header2[key])
               .size(0, 0);

          } else {
            doc.text(invoice.header2[key]);
          }
        }
        doc.drawLine();

        // Imprimir el contenido del ticket
        for (let plu of invoice.plus) {
          doc.drawLine()
             .align(escpos.TextAlignment.Center)
             .size(1, 1)
             .text(plu.category)
             .size(0, 0)
          for (let p of plu.products) {
            let stringPRoduct = "X" + Number(p.units).toString() + " " + p.name;
            doc.align(escpos.TextAlignment.LeftJustification)
               .size(0, 0)
               .drawLine()
               .size(1, 1)
               .text(stringPRoduct)
               .size(0, 0);
            if (p.suplementos && p.suplementos.length && p.suplementos.length > 0) {
              for (let sup of p.suplementos) {
                if (beep) {
                  doc.size(1, 1)
                     .text("-> EXTRA " + sup.name)
                     .size(0, 0)
                } else {
                  doc.size(1, 1)
                     .text("-> " + sup.name)
                     .size(0, 0);
                };
              }
            }
            if (p.description) {
              doc.text("// " + p.description)

            };
          }
        }
        doc.size(0, 0)
           .style([escpos.FontStyle.Normal])

        // Pie de página
        doc.feed(2)
           .drawLine()
           .drawLine();
        if (invoice.footer) {
          for (let key in invoice.footer) {
            doc.align(escpos.TextAlignment.Center)
               .size(1, 2)
               .text(invoice.footer[key])
               .size(0, 0)
               .drawLine()
               .drawLine();
          }
        }

        doc.feed(5)
           .cut();

        if (beep) {
          doc.cashDraw()
             .beep(30, 100);
        }

        const print = doc.generateUInt8Array();

        this.logRawCommands();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  }

  public async printCierreOrSnapshotCaja(ip, port, info, isSnapshot) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        // // Encabezado (SNAPSHOT o CIERRE CAJA)
        doc.drawLine()
           .align(escpos.TextAlignment.Center)
           .size(1, 2)
           .style([escpos.FontStyle.Bold])
           .text(isSnapshot ? "- SNAPSHOT (X) -" : "- CIERRE CAJA (Z) -")
           .size(0, 0)  
           .style([escpos.FontStyle.Normal])
           .drawLine();

        // Referencia y datos del encabezado
        doc.align(escpos.TextAlignment.LeftJustification)
           .style([escpos.FontStyle.Bold])
           .size(0, 1)
           .text(info.referencia)
           .style([escpos.FontStyle.Normal])
           .size(0, 0);

        for (let key in info.header) {
          doc.text(info.header[key]);
        }
        doc.drawLine()
           .drawLine();

        // Sección "AUTOMÁTICOS SISTEMA"
        doc.style([escpos.FontStyle.Bold])
           .size(1, 1)
           .text("AUTOMÁTICOS SISTEMA")
           .size(0, 0)
           .style([escpos.FontStyle.Normal])
           .drawLine();

        // Saldo inicial
        doc.size(0, 1)
           .text(this.makeInvoiceString("Saldo inicial:", "", "", info.saldo_inicial, 48, -1))
           .size(0, 0)
           .drawLine();

        // Cobros registrados
        doc.style([escpos.FontStyle.Bold])
           .text(this.makeInvoiceString("Cobros Registados (incluye propinas)", "", "", info.importe_ingresos, 48, 2))
           .style([escpos.FontStyle.Normal]);

        for (let c of info.cobros) {
          doc.text(this.makeInvoiceString("  " + c.name, "", "", c.importe, 48, -1));
        }

        // Otros movimientos
        doc.style([escpos.FontStyle.Bold])
           .text(this.makeInvoiceString("Otros Movimientos", "", "", info.importe_movimientos, 48, 2));

        for (let m of info.movimientos) {
          doc.text(this.makeInvoiceString("  " + m.name, "", "", m.importe, 48, -1));
        }

        // Propinas
        doc.text(this.makeInvoiceString("Propinas", "", "", info.importe_propinas, 48, 2))
           .style([escpos.FontStyle.Normal])
           .drawLine();

        // SALDO FINAL CALCULADO
        doc.size(0, 1)
           .text(this.makeInvoiceString("SALDO FINAL:", "", "", info.saldo_final_calculado, 48, -1))
           .size(0, 0);

        for (let s of info.totales) {
          doc.style([escpos.FontStyle.Bold])
             .text(this.makeInvoiceString("  " + s.name, "", "", s.importe_calculado, 48, 2))
             .style([escpos.FontStyle.Normal]);
        }
           doc.drawLine()
           .drawLine();

        // Sección "MANUAL CAMARERO"
        doc.style([escpos.FontStyle.Bold])
           .size(1, 1)
           .text("MANUAL CAMARERO")
           .size(0, 0)
           .style([escpos.FontStyle.Normal])
           .drawLine();

        // SALDO FINAL MANUAL
        doc.size(0, 1)
           .text(this.makeInvoiceString("SALDO FINAL:", "", "", info.saldo_final_manual, 48, -1))
           .size(0, 0);

        for (let s of info.totales) {
          doc.style([escpos.FontStyle.Bold])
             .text(this.makeInvoiceString("  " + s.name, "", "", s.importe_manual, 48, 2))
             .style([escpos.FontStyle.Normal]);
        }

        doc.style([escpos.FontStyle.Normal])
           .drawLine()
           .feed(5)
           .cut();

        const print = doc.generateUInt8Array();

        this.logRawCommands();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);

    }

  }

  public async printInvoice(infoTicket) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const { ip, port, invoice, imagepath } = infoTicket;
        console.log("Opening Invoice: " + ip + ":" + port);
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        if (imagepath && imagepath.length > 0) {
          try {
            const logo = await escpos.ESCPOSImage.load(imagepath);
            // Añadir el logo al documento existente
            doc.image(logo, escpos.BitmapDensity.D24).generateUInt8Array();

          } catch (error) {
            console.error('Error loading logo:', error);
          }
        }

        
        // Encabezado
        let i = 0;
        for (let key in invoice.header) {
          if (i > 0) {
            doc.size(0, 0);
          }
          doc.align(escpos.TextAlignment.Center)
          .style([escpos.FontStyle.Bold])
            .size(1, 1)
            .text(invoice.header[key].trim())
            .size(0, 0)
            .newLine();
            ++i;
        }
        doc.style([escpos.FontStyle.Normal])
          .size(0, 0)
          .newLine();
          
          // Encabezado 2
          for (let key in invoice.header2) {
            doc.align(escpos.TextAlignment.Center)
            .text(invoice.header2[key].trim());
        }
        doc.feed(2)
        console.log('INVOICE', invoice)
        
        if (this.listHasValues(invoice.plusTarifas)) {
          // Contenido de tarifas
          // Titulo
          doc.style([escpos.FontStyle.Bold])
            .size(0, 1)
            .align(escpos.TextAlignment.LeftJustification)
            .text("Tarifas:")
            .style([escpos.FontStyle.Normal])
            .size(0, 0);
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("NOMBRE", "TARIFA", "MINS", "TOTAL", 48, 6))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          for (let plu of invoice.plusTarifas) {
            doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 8))
          }
        }

        // Contenido de servicios
        // Titulo
        if (this.listHasValues(invoice.plusServicios)) {
          doc.drawLine()
            .style([escpos.FontStyle.Bold])
            .size(0, 1)
            .align(escpos.TextAlignment.LeftJustification)
            .text("Servicios:")
            .style([escpos.FontStyle.Normal])
            .size(0, 0);
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("SERVICIO", "PVP", "UDS", "TOTAL", 48, 2))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          for (let plu of invoice.plusServicios) {
            doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 10))
          }
        }

        // Contenido del ticket
        if (this.listHasValues(invoice.plus || invoice.plusRestaurante)) {
          // Contenido de restaurante
          // Titulo
          if (this.listHasValues(invoice.plusServicios)) {
            doc.drawLine()
              .style([escpos.FontStyle.Bold])
              .size(0, 1)
              .align(escpos.TextAlignment.LeftJustification)
              .text("Restaurante:")
              .style([escpos.FontStyle.Normal])
              .size(0, 0);
          }
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("PRODUCTO", "PVP", "UDS", "TOTAL", 48, 2))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          if (invoice.plus) {
            for (let plu of invoice.plus) {
              doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 9))
            }
          }
          if (invoice.plusRestaurante) {
            for (let plu of invoice.plusRestaurante) {
              doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 9))
            }
          }
        }

        // Imprimir importe total ticket
        // IVA
        let cuota = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
        let base = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1) - this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
        base = this.roundNumberFunction(base);
        doc.drawLine()
          .size(0, 1)
          .text(this.makeInvoiceString("IVA: 10%", "BASE: " + cuota, " ", "Cuota: " + base, 48, 0))
          .size(0, 0);

        // Total
        this.drawLine();
        this.doubleHeight();
        this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0);
        this.normalFont();
        this.drawLine();
        doc.drawLine()
          .style([escpos.FontStyle.Bold])
          .size(0, 1)
          .text(this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0))
          .style([escpos.FontStyle.Normal])
          .size(0, 0)
          .drawLine();

        // Comensales
        if (invoice.total2) {
          for (let key in invoice.total2) {
            if (invoice.total2[key]) {
              const text = invoice.total2[key].trim();
              doc.align(escpos.TextAlignment.RightJustification)
                .text(text);
            }
          }
          doc.drawLine();
        }

        // Pie
        doc.drawLine();
        for (let key in invoice.footer) {
          if (invoice.footer[key]) {
            const text = invoice.footer[key].trim();
            doc.align(escpos.TextAlignment.LeftJustification)
               .text(text);
          }
        }
        doc.drawLine();

        if (invoice.footerCliente) {
          for (let key in invoice.footerCliente) {
            if (invoice.footerCliente[key]) {
              const text = invoice.footerCliente[key].trim();
              doc.align(escpos.TextAlignment.LeftJustification)
                .style([escpos.FontStyle.Normal])
                .size(0, 0)
                .text(text);
            }
          }
          doc.drawLine();
        }

        // Pie 2
        doc.feed(2)
          .align(escpos.TextAlignment.Center);
        let isFirstIteration = true;
        for (let key in invoice.footer2) {
          if (invoice.footer2[key]) {
            const text = invoice.footer2[key].trim();
            // Verifica si es la primera iteración y agrega los comandos especiales
            if (isFirstIteration) {
              doc.size(1, 1)
                .style([escpos.FontStyle.Bold])
                .text(text)
                .size(0, 0)
                .style([escpos.FontStyle.Normal])
                .newLine();
              isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
            } else {
              doc.size(0, 0)
                .style([escpos.FontStyle.Normal])
                .text(text)
                .newLine();
            }
          }
        }

        // Fecha y hora
        const date = new Date();
        const nowDate = date.toLocaleDateString('en-US', {
          timeZone: 'CET',
        });
        const nowTime = date.toLocaleTimeString('en-US', {
          timeZone: 'CET',
        });
        const nowText = `Printed at ${nowDate}, ${nowTime}`;

        doc.text(nowText)
          .feed(5)
          .cut();

        const print = doc.generateUInt8Array();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);
      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }

  }

  public async printPedido(pedidoToPrint) {
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const { ip, port, pedido, imagepath } = pedidoToPrint;
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        if (imagepath && imagepath.length > 0) {
          try {
            const logo = await escpos.ESCPOSImage.load(imagepath); // from cloud
            // const logo = await escpos.ESCPOSImage.load('/assets/la-mechada-express-logoimpresora.png'); // from local
            // const logo = await escpos.ESCPOSImage.load('/assets/goiko-grill-logoimpresora.png'); // from local

            // Añadir el logo al documento existente
            doc.image(logo, escpos.BitmapDensity.D24).generateUInt8Array();

          } catch (error) {
            console.error('Error loading logo:', error);
          }
        }

        // Encabezado
        doc.newLine();
        for (let key in pedido.header) {
          if (pedido.header[key]) {
            const text = pedido.header[key].trim();
            doc.align(escpos.TextAlignment.Center)
              .style([escpos.FontStyle.Bold])
              .size(1, 1)
              .text(text)
              .size(0, 0)
              .newLine();
          }
        }
        doc.style([escpos.FontStyle.Normal])
          .size(0, 0)
          .newLine();

        // Encabezado 2
        for (let key in pedido.header2) {
          if (pedido.header2[key]) {
            const text = pedido.header2[key].trim();
            doc.align(escpos.TextAlignment.Center)
              .text(text);
          }
        }

        // Contenido del ticket
        doc.feed(2)
          .style([escpos.FontStyle.Bold])
          .text(this.makeInvoiceString("PRODUCTO", "PVP", "UDS", "TOTAL", 48, 2))
          .style([escpos.FontStyle.Normal])
          .drawLine();
        for (let plu of pedido.plus) {
          doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1))
        }

        // Total
        doc.drawLine()
          .style([escpos.FontStyle.Bold])
          .size(0, 1)
          .text(this.makeInvoiceString("Total (impuestos incluidos)", "", "", pedido.totalImport['importe_ticket'], 48, 1))
          .style([escpos.FontStyle.Normal])
          .size(0, 0)
          .drawLine();

        // Comensales
        for (let key in pedido.total2) {
          if (pedido.total2[key]) {
            const text = pedido.total2[key].trim();
            doc.align(escpos.TextAlignment.RightJustification)
              .text(text);
          }
        }
        doc.drawLine()
          .drawLine()
          .newLine();

        // Pie
        for (let key in pedido.footer) {
          if (pedido.footer[key]) {
            const text = pedido.footer[key].trim();
            doc.align(escpos.TextAlignment.LeftJustification)
              .text(text);
          }
        }
        doc.drawLine();

        // Pie del cliente
        if (pedido.footerCliente) {
          for (let key in pedido.footerCliente) {
            if (pedido.footerCliente[key]) {
              const text = pedido.footerCliente[key].trim();
              doc.align(escpos.TextAlignment.LeftJustification)
                .style([escpos.FontStyle.Normal])
                .size(0, 0)
                .text(text);
            }
          }
          doc.drawLine();
        }

        // Pie 2
        doc.feed(2)
          .align(escpos.TextAlignment.Center);
        let isFirstIteration = true;
        for (let key in pedido.footer2) {
          if (pedido.footer2[key]) {
            const text = pedido.footer2[key].trim();
            // Verifica si es la primera iteración y agrega los comandos especiales
            if (isFirstIteration) {
              doc.size(1, 1)
                .style([escpos.FontStyle.Bold])
                .text(text)
                .size(0, 0)
                .style([escpos.FontStyle.Normal])
                .newLine();
              isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
            } else {
              doc.size(0, 0)
                .style([escpos.FontStyle.Normal])
                .text(text)
                .newLine();
            }
          }
        }

        // Fecha y hora
        const date = new Date();
        const nowDate = date.toLocaleDateString('en-US', {
          timeZone: 'CET',
        });
        const nowTime = date.toLocaleTimeString('en-US', {
          timeZone: 'CET',
        });
        const nowText = `Printed at ${nowDate}, ${nowTime}`;

        doc.text(nowText)
          .feed(5)
          .cut();

        const print = doc.generateUInt8Array();

        this.logRawCommands();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;

        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);

      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }
  }

  public async printActLudic(infoTicket) {
    console.log('INFO ACT LUDIC TICKET:', infoTicket);
    try {
      const connection = await this.jspmConnect();

      if (connection) {
        const { ip, port, invoice, imagepath } = infoTicket;
        console.log("Opening Invoice: " + ip + ":" + port);
        const escpos = Neodynamic.JSESCPOSBuilder;
        const doc = new escpos.Document();

        const printer = new JSPM.NetworkPrinter(port, ip);

        if (imagepath && imagepath.length > 0) {
          try {
            const logo = await escpos.ESCPOSImage.load(imagepath);
            // Añadir el logo al documento existente
            doc.image(logo, escpos.BitmapDensity.D24).generateUInt8Array();

          } catch (error) {
            console.error('Error loading logo:', error);
          }
        }

        // Encabezado
        let i = 0;
        for (let key in invoice.header) {
          if (i > 0) {
            doc.size(0, 0);
          }
          doc.align(escpos.TextAlignment.Center)
            .style([escpos.FontStyle.Bold])
            .size(1, 1)
            .text(invoice.header[key].trim())
            .size(0, 0)
            .newLine();
          ++i;
        }
        doc.style([escpos.FontStyle.Normal])
          .size(0, 0)
          .newLine();

        // Encabezado 2
        for (let key in invoice.header2) {
          doc.align(escpos.TextAlignment.Center)
            .text(invoice.header2[key].trim());
        }
        doc.feed(2)

        if (this.listHasValues(invoice.tarifas)) {
          // Contenido de tarifas
          // Titulo
          doc.style([escpos.FontStyle.Bold])
            .size(0, 1)
            .align(escpos.TextAlignment.LeftJustification)
            .text("Tarifas:")
            .style([escpos.FontStyle.Normal])
            .size(0, 0)
            .newLine();
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("NOMBRE", "TARIFA", "MINS", "TOTAL", 48, 2))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          for (let plu of invoice.tarifas) {
            doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 8))
          }
        }

        // Contenido de servicios
        // Titulo
        if (this.listHasValues(invoice.servicios)) {
          doc.drawLine()
            .style([escpos.FontStyle.Bold])
            .size(0, 1)
            .align(escpos.TextAlignment.LeftJustification)
            .text("Servicios:")
            .style([escpos.FontStyle.Normal])
            .size(0, 0)
            .newLine();
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("SERVICIO", "PVP", "UDS", "TOTAL", 48, 2))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          for (let plu of invoice.servicios) {
            doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 10))
          }
        }

        // Contenido del ticket
        if (this.listHasValues(invoice.plus)) {
          // Contenido de restaurante
          // Titulo
          if (this.listHasValues(invoice.servicios) && this.listHasValues(invoice.tarifas)) {
            doc.drawLine()
              .style([escpos.FontStyle.Bold])
              .size(0, 1)
              .align(escpos.TextAlignment.LeftJustification)
              .text("Restaurante:")
              .style([escpos.FontStyle.Normal])
              .size(0, 0)
              .newLine();
          }
          // Contenido
          doc.style([escpos.FontStyle.Bold])
            .text(this.makeInvoiceString("PRODUCTO", "PVP", "UDS", "TOTAL", 48, 2))
            .style([escpos.FontStyle.Normal])
            .drawLine();
          for (let plu of invoice.plus) {
            doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 9))
          }
        }

        // Imprimir importe total ticket
        // IVA
        if (Object.keys(invoice.iva).length > 0) {
          console.log('IVA:', invoice.iva);
          for (const key in invoice.iva) {
            const percentage = this.roundNumberFunction(Math.round(Number(key)));
            const accumulated = invoice.iva[key].accumulated_without_iva.toFixed(2);

            let cuota = this.roundNumberFunction(accumulated * percentage / 100);
            let base = accumulated - cuota;

            let space = "";
            let dataLength = base.toFixed(2).toString().length + cuota.toFixed(2).toString().length;
            if(dataLength == 11) {
              space = " ";
            } else if (dataLength == 10) {
              space = "  ";
            } else if (dataLength == 9) {
              space = "   ";
            } else if (dataLength == 8) {
              space = "    ";
            } else if (dataLength == 7) {
              space = "     ";
            } else if (dataLength == 6) {
              space = "      ";
            } else if (dataLength == 5) {
              space = "       ";
            } else if (dataLength == 4) {
              space = "        ";
            } else if (dataLength == 3) {
              space = "         ";
            } else if (dataLength == 2) {
              space = "          ";
            } else if (dataLength == 1) {
              space = "           ";
            } else if (dataLength == 0) {
              space = "            ";
            }

            doc.drawLine()
              .size(0, 1)
              .text(this.makeInvoiceString("IVA: " + percentage + "%", "BASE: " + base.toFixed(2) + space, "", "Cuota: " + cuota.toFixed(2), 48, 0))
              .size(0, 0);
          }
        } else {
          console.log("El objeto 'iva' está vacío.");
        }

        // Total
        doc.drawLine()
          .style([escpos.FontStyle.Bold])
          .size(0, 1)
          .text(this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0))
          .style([escpos.FontStyle.Normal])
          .size(0, 0)
          .drawLine();

        // Pie
        doc.drawLine();
        for (let key in invoice.footer) {
          if (invoice.footer[key]) {
            const text = invoice.footer[key].trim();
            doc.align(escpos.TextAlignment.LeftJustification)
              .text(text);
          }
        }
        doc.drawLine();

        if (invoice.footerCliente) {
          for (let key in invoice.footerCliente) {
            if (invoice.footerCliente[key]) {
              const text = invoice.footerCliente[key].trim();
              doc.align(escpos.TextAlignment.LeftJustification)
                .style([escpos.FontStyle.Normal])
                .size(0, 0)
                .text(text);
            }
          }
          doc.drawLine();
        }

        // Pie 2
        doc.feed(2)
          .align(escpos.TextAlignment.Center);
        let isFirstIteration = true;
        for (let key in invoice.footer2) {
          if (invoice.footer2[key]) {
            const text = invoice.footer2[key].trim();
            // Verifica si es la primera iteración y agrega los comandos especiales
            if (isFirstIteration) {
              doc.size(1, 1)
                .style([escpos.FontStyle.Bold])
                .text(text)
                .size(0, 0)
                .style([escpos.FontStyle.Normal])
                .newLine();
              isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
            } else {
              doc.size(0, 0)
                .style([escpos.FontStyle.Normal])
                .text(text)
                .newLine();
            }
          }
        }

        // Fecha y hora
        const date = new Date();
        const nowDate = date.toLocaleDateString('en-US', {
          timeZone: 'CET',
        });
        const nowTime = date.toLocaleTimeString('en-US', {
          timeZone: 'CET',
        });
        const nowText = `Printed at ${nowDate}, ${nowTime}`;

        doc.text(nowText)
          .feed(5)
          .cut();

        const print = doc.generateUInt8Array();

        // Crear un ClientPrintJob
        let commandsPrintJob = new JSPM.ClientPrintJob();
        commandsPrintJob.clientPrinter = printer;
        commandsPrintJob.binaryPrinterCommands = print;
        commandsPrintJob.sendToClient();

        console.log('Print Job sent to printer', commandsPrintJob);
      }
    } catch (error) {
      console.error("Error al conectar con JSPrintManager:", error);
    }

  }

  // public async printActLudicGeneralPrueba(actLudicToPrint) {
  //   try {
  //     const connection = await this.jspmConnect();

  //     if (connection) {
  //       const { ip, port, invoice, imagepath } = actLudicToPrint;
  //       const escpos = Neodynamic.JSESCPOSBuilder;
  //       const doc = new escpos.Document();

  //       const printer = new JSPM.NetworkPrinter(port, ip);

  //       if (imagepath && imagepath.length > 0) {
  //         try {
  //           const logo = await escpos.ESCPOSImage.load(imagepath);
  //           // Añadir el logo al documento existente
  //           doc.image(logo, escpos.BitmapDensity.D24).generateUInt8Array();

  //         } catch (error) {
  //           console.error('Error loading logo:', error);
  //         }
  //       }

  //       // Encabezado
  //       for (let key in invoice.header) {
  //         if (invoice.header[key]) {
  //           const text = invoice.header[key].trim();
  //           doc.align(escpos.TextAlignment.Center)
  //             .style([escpos.FontStyle.Bold])
  //             .size(1, 1)
  //             .text(text)
  //             .size(0, 0)
  //             .newLine();
  //         }
  //       }
  //       doc.style([escpos.FontStyle.Normal])
  //         .size(0, 0)
  //         .newLine();

  //       // Encabezado 2
  //       for (let key in invoice.header2) {
  //         if (invoice.header2[key]) {
  //           const text = invoice.header2[key].trim();
  //           doc.align(escpos.TextAlignment.Center)
  //             .text(text);
  //         }
  //       }

  //       doc.feed(2)

  //       // Contenido de tarifas
  //       // Titulo
  //       doc.drawLine()
  //         .style([escpos.FontStyle.Bold])
  //         .size(0, 1)
  //         .align(escpos.TextAlignment.LeftJustification)
  //         .text("Tarifas:")
  //         .style([escpos.FontStyle.Normal])
  //         .size(0, 0)
  //         .drawLine();
  //       // Contenido
  //       doc.style([escpos.FontStyle.Bold])
  //         .text(this.makeInvoiceString("NOMBRE", "TARIFA", "MINS", "TOTAL", 48, 6))
  //         .style([escpos.FontStyle.Normal])
  //         .drawLine();
  //       for (let plu of invoice.plusTarifas) {
  //         doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1))
  //       }
  //       doc.drawLine();

  //       // Contenido de servicios
  //       // Titulo
  //       doc.drawLine()
  //         .style([escpos.FontStyle.Bold])
  //         .size(0, 1)
  //         .align(escpos.TextAlignment.LeftJustification)
  //         .text("Servicios:")
  //         .style([escpos.FontStyle.Normal])
  //         .size(0, 0)
  //         .drawLine();
  //       // Contenido
  //       doc.style([escpos.FontStyle.Bold])
  //         .text(this.makeInvoiceString("SERVICIO", "PVP", "UDS", "TOTAL", 48, 2))
  //         .style([escpos.FontStyle.Normal])
  //         .drawLine();
  //       for (let plu of invoice.plusServicios) {
  //         doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1))
  //       }
  //       doc.drawLine();


  //       // Contenido de restaurante
  //       // Titulo
  //       doc.drawLine()
  //         .style([escpos.FontStyle.Bold])
  //         .size(0, 1)
  //         .align(escpos.TextAlignment.LeftJustification)
  //         .text("Restaurante:")
  //         .style([escpos.FontStyle.Normal])
  //         .size(0, 0)
  //         .drawLine();
  //       // Contenido
  //       doc.style([escpos.FontStyle.Bold])
  //         .text(this.makeInvoiceString("PRODUCTO", "PVP", "UDS", "TOTAL", 48, 2))
  //         .style([escpos.FontStyle.Normal])
  //         .drawLine();
  //       for (let plu of invoice.plusRestaurante) {
  //         doc.text(this.makeInvoiceString(plu.name, plu.ppu, plu.units, plu.total, 48, 1))
  //       }
  //       doc.drawLine();

  //       // Total
  //       // doc.drawLine()
  //       //   .style([escpos.FontStyle.Bold])
  //       //   .size(0, 1)
  //       //   .text(this.makeInvoiceString("Total (impuestos incluidos)", "", "", pedido.totalImport['importe_ticket'], 48, 1))
  //       //   .style([escpos.FontStyle.Normal])
  //       //   .size(0, 0)
  //       //   .drawLine();

  //       // doc.drawLine()
  //       //   .newLine();

  //       // Imprimir importe total ticket
  //       // IVA
  //       let cuota = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
  //       let base = this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1) - this.roundNumberFunction(invoice.totalImport['importe_ticket_final'] / 1.1);
  //       base = this.roundNumberFunction(base);
  //       doc.drawLine()
  //         .size(0, 1)
  //         .text(this.makeInvoiceString("IVA: 10%", "BASE: " + cuota, " ", "Cuota: " + base, 48, 0))
  //         .size(0, 0);

  //       // Total
  //       this.drawLine();
  //       this.doubleHeight();
  //       this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0);
  //       this.normalFont();
  //       this.drawLine();
  //       doc.drawLine()
  //         .style([escpos.FontStyle.Bold])
  //         .size(0, 1)
  //         .text(this.makeInvoiceString("Total (impuestos incluidos)", invoice.totalImport['importe_ticket'], invoice.totalImport['descuento_ticket'], invoice.totalImport['importe_ticket_final'], 48, 0))
  //         .style([escpos.FontStyle.Normal])
  //         .size(0, 0)
  //         .drawLine();

  //       doc.drawLine()
  //         .newLine();

  //       // Pie
  //       for (let key in invoice.footer) {
  //         if (invoice.footer[key]) {
  //           const text = invoice.footer[key].trim();
  //           doc.align(escpos.TextAlignment.LeftJustification)
  //             .text(text);
  //         }
  //       }
  //       doc.drawLine();

  //       // Pie del cliente
  //       if (invoice.footerCliente) {
  //         for (let key in invoice.footerCliente) {
  //           if (invoice.footerCliente[key]) {
  //             const text = invoice.footerCliente[key].trim();
  //             doc.align(escpos.TextAlignment.LeftJustification)
  //               .style([escpos.FontStyle.Normal])
  //               .size(0, 0)
  //               .text(text);
  //           }
  //         }
  //         doc.drawLine();
  //       }

  //       // Pie 2
  //       // doc.feed(2)
  //       //   .align(escpos.TextAlignment.Center);
  //       // let isFirstIteration = true;
  //       // for (let key in pedido.footer2) {
  //       //   if (pedido.footer2[key]) {
  //       //     const text = pedido.footer2[key].trim();
  //       //     // Verifica si es la primera iteración y agrega los comandos especiales
  //       //     if (isFirstIteration) {
  //       //       doc.size(1, 1)
  //       //         .style([escpos.FontStyle.Bold])
  //       //         .text(text)
  //       //         .size(0, 0)
  //       //         .style([escpos.FontStyle.Normal])
  //       //         .newLine();
  //       //       isFirstIteration = false; // Actualiza la variable para las siguientes iteraciones
  //       //     } else {
  //       //       doc.size(0, 0)
  //       //         .style([escpos.FontStyle.Normal])
  //       //         .text(text)
  //       //         .newLine();
  //       //     }
  //       //   }
  //       // }

  //       // Fecha y hora
  //       const date = new Date();
  //       const nowDate = date.toLocaleDateString('en-US', {
  //         timeZone: 'CET',
  //       });
  //       const nowTime = date.toLocaleTimeString('en-US', {
  //         timeZone: 'CET',
  //       });
  //       const nowText = `Printed at ${nowDate}, ${nowTime}`;

  //       doc.feed(2)
  //         .align(escpos.TextAlignment.Center)
  //         .text(nowText)
  //         .feed(5)
  //         .cut();

  //       const print = doc.generateUInt8Array();

  //       this.logRawCommands();

  //       // Crear un ClientPrintJob
  //       let commandsPrintJob = new JSPM.ClientPrintJob();
  //       commandsPrintJob.clientPrinter = printer;
  //       commandsPrintJob.binaryPrinterCommands = print;
  //       commandsPrintJob.sendToClient();

  //       console.log('Print Job sent to printer', commandsPrintJob);

  //     }
  //   } catch (error) {
  //     console.error("Error al conectar con JSPrintManager:", error);
  //   }
  // }

  // public async testPrint (ip, port) {
  //   try {
  //     const connection = await this.jspmConnect();
  //     if (connection) {
  //       // const imagePath = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAABFCAIAAAAKO6eOAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAd5SURBVHhe7Z1RgqM4DETnXDkQ58lpcpkcZteGAmxLJcvB0+ll9b56SFnIchmMQ0//CYIgCIIgCIIgCIL/Df8EwX2ByxlQBcEdgcsZUAXBHYHLGVAFwR2ByxlQBcEdgcsZUAXBHYHLGVBN5/1cHtsZHs83jgXBD7NZkALVbF4L4mfC/8GXgAMZUE3m/cSFfyXcH3wJOJAB1XSKi3+YP/gWsCADqpm836/X67kc6/7l+UwH3jEFgh9nsyAFquskzy+Pcr2jkqbCK6ZB8FPAdgyoXGR/r42ShwsLv9OFvmv7msdS3Qv2uLFICuay2YoClYdqH2d55UPJ+IO+L8hTYA1Sxgj/BxOBqxhQORD7OPWBz8gzoJpVmFZBMAOYigGVh9qlnEdaGFVLofXfzpkS1/5gInAVAyoX5/e3Oudqnuz3dx+MU4RNGQQzgK8YUA2gLXjEVk4pai/nx8NzRfg+mA/MxYDKjb78kdds69sucg+5uugxn0O0yWU12JMhyz0j1/EWNWr7S9eG9+uZl57NbTcfWPJVa7zqa8AcEaFO1qDP4V3t6RnuIBIDKidkZBP14JKVz4rhObdDVEz3K6Gd+jE3X/X+VPe796L37bce7oAJV8zpGTagNQMqF9z7K4/HOecrZ51D13tyuHSNM92s+M/sTiknQiVXksJQrya5X19fWvRm6HDATsj5GUrQkAGVAzGyy0umf+RXjKF2DKT5IqNu4nFs94vApvmbQvv8P8P75FyDMTqloHB72dUyIJnPz1AFrRhQ9WnT3XvVzODtBlCLc8biFpcObv1ggYfpFbQO3FG3Ve77nwQc7s5193/s1Ix2pl5lbZSI0zNkoAkDqi5NvqU5lNocr7itpEcXqSi60MQeGumC3hhVhh4Sr+gjduj0jz/oixpoIA7rWb0vZyy4xbn0rsmI3oDzM6SgAQOqHk3CrTeGnoby3aFuPsf+sqjLUgUus65P2e42yB5mdBesSv2jjzqihvJH0jPRAxAb1loqkgXStWnAK+n0DA2gZ0DVoUlCswbrVIunrX+sS2Sllmd96Ixbn/DxfLbJq2mSPqZ7G36q+KwX+jncsfQMaXPdXaW8r6jIcmxUkp3K6RlaQM6AqkNrFrVbSXUmeuxQpdtCkT5vCsEKU9ko7n81x/aiicNiSHyJGnjHR6CewRtN9YpVzp65ep8PMz1DE6gZUCnsu5NpNZaWdKu4In+rcSiahU+TW9PcarmSirHPJPk9GkWWKbWtT40qN0ohS/DxUN3Z4s9aoMb3xhtvrLY4e9/5eJzpGZpAzYBKoM84J6IzV6K5S626v6ndFkweExW2zqoOR4nXqypqdGdEvc5mY7XJ2XtXNt2CnPHmZ2gCNQMqgZ6lDyWzbn0MvF6SKeeWzdF8qE5mzVbkZ1fX7I43X4Ia2xnzA6PYTXQbtNl0R/dMYXqGNlAzoBJUp5RbIjZirPQi+nD2UzvJmkdzWH8WGHS/0SOnTznT3W83VpucvXdlc9X9lzI0gZoBlYJ73Z9/GFz37xukf3/dn6jP3n75oGkS/eqqQ+4cFAs1rrcK4407LVy9VEUlRYPpGZpAzYCqQ20sNsTT9ny8Y13D3G8ODhISEpboiRq136zLlcEev06qDYrT9T5fsQq8UmQwPUMTqBlQ9aj7pybbLcGGo61VCwNZJpRIr9/KfiqRfD8Htb8fpl6ixvW6n4wCbd631rj5lBZlWaZnaAE5A6oeTQ7tII9817veFurmTUG8XWuQddoD6RXM7AoxJP9V9xNz6QtIUpdaS0Wsp0qDqizTMzSAngFVlyaNsjtKhr/kPZ8jkl5wS/DL3N+jOC8xTBqFv/KeTxHyTYPWZZmfIQUNGFD1aVPeM0gPxziy8qve8TxD6QN4DsqN3K8VYgCt/JcCZtqyTM+QgSYMqDy0w+J9v//IVo6rfL//gn0s96vlLs4lUuvnobr0Qvo7atwezXk/dRdP/6OsQLqmi7DzM1RBKwZULjoZO3+3y4wxMq9bZHpFNC334uObuT8xbq9O7vwNZoN6MVMzPUMFNGRA5YSPTJ1Y3THrs4rx3pXIwOVckqmbn/ZT+eXuz7gNq12dNXJAp2Ufx563xfQMG9CaAZUbfWzEA3vpRDEy5Ld72xij2O4XmVdp3dP9G/lhNN9zW99uLyLzazOFBcwR8W4zlE6mZ3iAQAyoBtCu3eIGZ7lfn+9XvR8EEpiLAZULcs0+ODfy6xmy27//n5ynJ4dVGQRTgK8YUHlw35LT7aqaJuu/TdefTFg6BMEOXMWAyoG4nmtLoFHy7aKeVbECCuYBUzGg8lC5dDNpelr5fAbsmwLVLIprfzARuIoBlYvjcbXefuqu5iXNU/LxGBzeD6ay2YoC1XXWVxm6k0BsDgXBXwS2Y0A1kfyyU/E3Gx/J8PE3G4PvsFqQA9V0ioeEWM4E3wIWZEA1GX2/Pwh+GDiQAdVsqv2hcH/wJeBABlTTOb8XDu8HX2OzIAWqILgjcDkDqiC4I3A5A6oguCNwOQOqILgjcDkDqiC4I3A5A6oguCNweRAEQRAEQRAEQRDcnT9//gXTok1btWRH9wAAAABJRU5ErkJggg=='
  //       // const imagePath = 'https://movin.cloud/empresas/2254/info/goiko-grill-logoimpresora.png';
  //       const escpos = Neodynamic.JSESCPOSBuilder;
  //       const doc = new escpos.Document();
  //       const printer = new JSPM.NetworkPrinter(port, ip);
  //       const imagePath = '/assets/goiko-grill-logoimpresora.png'

  //       // var escpos = Neodynamic.JSESCPOSBuilder;
  //       // var doc = new escpos.Document();
  //       escpos.ESCPOSImage.load(imagePath)
  //         .then(logo => {
  //           var escposCommands = doc
  //             .image(logo, escpos.BitmapDensity.D24)
  //             .font(escpos.FontFamily.A)
  //             .align(escpos.TextAlignment.Center)
  //             .style([escpos.FontStyle.Bold])
  //             .size(1, 1)
  //             .text("This is a BIG text")
  //             .font(escpos.FontFamily.B)
  //             .size(0, 0)
  //             .text("Normal-small text")
  //             .text("Tendré que ir a España. ¿Cómo? Por avión.")
  //             .linearBarcode('1234567', escpos.Barcode1DType.EAN8, new escpos.Barcode1DOptions(2, 100, true, escpos.BarcodeTextPosition.Below, escpos.BarcodeFont.A))
  //             .qrCode('https://mycompany.com', new escpos.BarcodeQROptions(escpos.QRLevel.L, 6))
  //             .pdf417('PDF417 data to be encoded here', new escpos.BarcodePDF417Options(3, 3, 0, 0.1, false))
  //             .feed(5)
  //             .cut()
  //             .generateUInt8Array();

  //           console.log('TEST: Escpos Commands', escposCommands);

  //           // create ClientPrintJob
  //           var cpj = new JSPM.ClientPrintJob();
  //           cpj.clientPrinter = printer;
  //           cpj.binaryPrinterCommands = escposCommands;

  //           cpj.sendToClient();
  //           // Crear un TextDecoder
  //           const decoder = new TextDecoder('cp1252');
  //           // Decodificar el Uint8Array a texto
  //           const texto = decoder.decode(cpj.binaryPrinterCommands);

  //           console.log(texto);

  //           console.log('TEST: Print Job sent to printer', cpj);

  //         });
        
  //     }

  //   } catch (error) {
  //     console.error("Error al conectar con JSPrintManager:", error);
  //   }
  // }

}
